export const umweltbauSubmenuData = (windowWidth) =>
  windowWidth >= 1024
    ? [
        // {
        //   type: "BfzTopics",
        //   links: [
        //     {
        //       type: "SubmenuLink",
        //       label: "Nachrichten",
        //       link: "/fachzeitschriften/umweltbau/nachrichten",
        //     },
        //     {
        //       type: "SubmenuLink",
        //       label: "Rohrvortrieb",
        //       link: "/fachzeitschriften/umweltbau/rohrvortrieb",
        //     },
        //     {
        //       type: "SubmenuLink",
        //       label: "Horizontalbohren",
        //       link: "/fachzeitschriften/umweltbau/horizontalbohren",
        //     },
        //     {
        //       type: "SubmenuLink",
        //       label: "Kanalsanierung",
        //       link: "/fachzeitschriften/umweltbau/kanalsanierung",
        //     },
        //     {
        //       type: "SubmenuLink",
        //       label: "Kanalbau und -betrieb",
        //       link: "/fachzeitschriften/umweltbau/kanalbau-kanalbetrieb",
        //     },
        //     {
        //       type: "SubmenuLink",
        //       label: "Zustandserfassung",
        //       link: "/fachzeitschriften/umweltbau/zustandserfassung",
        //     },
        //     {
        //       type: "SubmenuLink",
        //       label: "Leitungsbau",
        //       link: "/fachzeitschriften/umweltbau/leitungsbau",
        //     },
        //     {
        //       type: "SubmenuLink",
        //       label: "Abwassertechnik",
        //       link: "/fachzeitschriften/umweltbau/abwassertechnik",
        //     },
        //     {
        //       type: "SubmenuLink",
        //       label: "Grundstücksentwässerung",
        //       link: "/fachzeitschriften/umweltbau/grundstuecksentwaesserung",
        //     },
        //     {
        //       type: "SubmenuLink",
        //       label: "Regenwassermanagement",
        //       link: "/fachzeitschriften/umweltbau/regenwassermanagement",
        //     },
        //   ],
        // },
        {
          type: "SubmenuLink",
          label: "Nachrichten",
          link: "/fachzeitschriften/umweltbau/nachrichten",
        },
        {
          type: "SubmenuLink",
          label: "Rohrvortrieb",
          link: "/fachzeitschriften/umweltbau/rohrvortrieb",
        },
        {
          type: "SubmenuLink",
          label: "Horizontalbohren",
          link: "/fachzeitschriften/umweltbau/horizontalbohren",
          additional_classes: ["is-hidden-until-widescreen-flex"],
        },
        {
          type: "SubmenuLink",
          label: "Kanalsanierung",
          link: "/fachzeitschriften/umweltbau/kanalsanierung",
          additional_classes: ["is-hidden-until-fullhd-flex"],
        },
        {
          type: "DropdownMenu",
          label: "mehr",
          page: "umweltbau",
          dropdown_menu_items: [
            {
              type: "SubmenuLink",
              label: "Horizontalbohren",
              link: "/fachzeitschriften/umweltbau/horizontalbohren",
              additional_classes: ["is-hidden-widescreen"],
            },
            {
              type: "SubmenuLink",
              label: "Kanalsanierung",
              link: "/fachzeitschriften/umweltbau/kanalsanierung",
              additional_classes: ["is-hidden-fullhd"],
            },
            {
              type: "SubmenuLink",
              label: "Kanalbau und -betrieb",
              link: "/fachzeitschriften/umweltbau/kanalbau-kanalbetrieb",
            },
            {
              type: "SubmenuLink",
              label: "Zustandserfassung",
              link: "/fachzeitschriften/umweltbau/zustandserfassung",
            },
            {
              type: "SubmenuLink",
              label: "Leitungsbau",
              link: "/fachzeitschriften/umweltbau/leitungsbau",
            },
            {
              type: "SubmenuLink",
              label: "Abwassertechnik",
              link: "/fachzeitschriften/umweltbau/abwassertechnik",
            },
            {
              type: "SubmenuLink",
              label: "Grundstücksentwässerung",
              link: "/fachzeitschriften/umweltbau/grundstuecksentwaesserung",
            },
            {
              type: "SubmenuLink",
              label: "Regenwassermanagement",
              link: "/fachzeitschriften/umweltbau/regenwassermanagement",
            },
          ],
        },
        {
          type: "SubmenuSpacer",
        },
        {
          type: "DropdownMenu",
          label: "Bauverfahren",
          link: "/fachzeitschriften/umweltbau/bauverfahren",
          page: "umweltbau",
          dropdown_menu_items: [
            {
              type: "SubmenuLink",
              label: "Berstlining",
              link: "/fachzeitschriften/umweltbau/bauverfahren/berstlining",
            },
            {
              type: "SubmenuLink",
              label: "Close-Fit Verfahren",
              link: "/fachzeitschriften/umweltbau/bauverfahren/close-fit-verfahren",
            },
            {
              type: "SubmenuLink",
              label: "Direct Pipe",
              link: "/fachzeitschriften/umweltbau/bauverfahren/direct-pipe-verfahren",
            },
            {
              type: "SubmenuLink",
              label: "E-Power Pipe",
              link: "/fachzeitschriften/umweltbau/bauverfahren/e-power-pipe",
            },
            {
              type: "SubmenuLink",
              label: "Erdraketen",
              link: "/fachzeitschriften/umweltbau/bauverfahren/erdraketen",
            },
            {
              type: "SubmenuLink",
              label: "Flutungsverfahren",
              link: "/fachzeitschriften/umweltbau/bauverfahren/flutungsverfahren",
            },
            {
              type: "SubmenuLink",
              label: "Horizontal-spülbohrverfahren",
              link: "/fachzeitschriften/umweltbau/bauverfahren/horizontalspuelbohrverfahren",
            },
            {
              type: "SubmenuLink",
              label: "Microtunneling",
              link: "/fachzeitschriften/umweltbau/bauverfahren/microtunneling",
            },
            {
              type: "SubmenuLink",
              label: "Pflugverfahren",
              link: "/fachzeitschriften/umweltbau/bauverfahren/pflugverfahren",
            },
            {
              type: "SubmenuLink",
              label: "Pipe Express",
              link: "/fachzeitschriften/umweltbau/bauverfahren/pipe-express",
            },
            {
              type: "SubmenuLink",
              label: "Rammverfahren",
              link: "/fachzeitschriften/umweltbau/bauverfahren/rammverfahren",
            },
            {
              type: "SubmenuLink",
              label: "Schlauchlining",
              link: "/fachzeitschriften/umweltbau/bauverfahren/schlauchlining",
            },
            {
              type: "SubmenuLink",
              label: "Sprühschleuderverfahren",
              link: "/fachzeitschriften/umweltbau/bauverfahren/spruehschleuderverfahren",
            },
            {
              type: "SubmenuLink",
              label: "Wickelrohrverfahren",
              link: "/fachzeitschriften/umweltbau/bauverfahren/wickelrohrverfahren",
            },
            {
              type: "SubmenuLink",
              label: "Einzelrohrlining",
              link: "/fachzeitschriften/umweltbau/bauverfahren/einzelrohrlining",
            },
          ],
        },
        {
          type: "SubmenuLink",
          label: "Termine",
          link: "/fachzeitschriften/umweltbau/termine",
        },
        {
          type: "SubmenuSpacer",
        },
        {
          type: "SubmenuLink",
          label: "Jobs",
          link: "/fachzeitschriften/jobs-in-der-bauwirtschaft",
        },
        {
          type: "SubmenuSpacer",
        },
        {
          type: "BfzLogo",
          link: "/fachzeitschriften/umweltbau",
          page: "umweltbau",
          width: "150px",
          height: "32px",
          title: "B_I umweltbau Logo",
        },
      ]
    : [
        {
          type: "DropdownMenuMobile",
          label: "Themen",
          page: "umweltbau",
          dropdown_menu_items: [
            {
              type: "SubmenuLink",
              label: "Nachrichten",
              link: "/fachzeitschriften/umweltbau/nachrichten",
            },
            {
              type: "SubmenuLink",
              label: "Rohrvortrieb",
              link: "/fachzeitschriften/umweltbau/rohrvortrieb",
            },
            {
              type: "SubmenuLink",
              label: "Horizontalbohren",
              link: "/fachzeitschriften/umweltbau/horizontalbohren",
            },
            {
              type: "SubmenuLink",
              label: "Kanalsanierung",
              link: "/fachzeitschriften/umweltbau/kanalsanierung",
            },
            {
              type: "SubmenuLink",
              label: "Kanalbau und -betrieb",
              link: "/fachzeitschriften/umweltbau/kanalbau-kanalbetrieb",
            },
            {
              type: "SubmenuLink",
              label: "Zustandserfassung",
              link: "/fachzeitschriften/umweltbau/zustandserfassung",
            },
            {
              type: "SubmenuLink",
              label: "Leitungsbau",
              link: "/fachzeitschriften/umweltbau/leitungsbau",
            },
            {
              type: "SubmenuLink",
              label: "Abwassertechnik",
              link: "/fachzeitschriften/umweltbau/abwassertechnik",
            },
            {
              type: "SubmenuLink",
              label: "Grundstücksentwässerung",
              link: "/fachzeitschriften/umweltbau/grundstuecksentwaesserung",
            },
            {
              type: "SubmenuLink",
              label: "Regenwassermanagement",
              link: "/fachzeitschriften/umweltbau/regenwassermanagement",
            },
          ],
        },
        {
          type: "DropdownMenuMobile",
          label: "Verfahren",
          page: "umweltbau",
          dropdown_menu_items: [
            {
              type: "SubmenuLink",
              label: "Berstlining",
              link: "/fachzeitschriften/umweltbau/bauverfahren/berstlining",
            },
            {
              type: "SubmenuLink",
              label: "Close-Fit Verfahren",
              link: "/fachzeitschriften/umweltbau/bauverfahren/close-fit-verfahren",
            },
            {
              type: "SubmenuLink",
              label: "Direct Pipe",
              link: "/fachzeitschriften/umweltbau/bauverfahren/direct-pipe-verfahren",
            },
            {
              type: "SubmenuLink",
              label: "E-Power Pipe",
              link: "/fachzeitschriften/umweltbau/bauverfahren/e-power-pipe",
            },
            {
              type: "SubmenuLink",
              label: "Erdraketen",
              link: "/fachzeitschriften/umweltbau/bauverfahren/erdraketen",
            },
            {
              type: "SubmenuLink",
              label: "Flutungsverfahren",
              link: "/fachzeitschriften/umweltbau/bauverfahren/flutungsverfahren",
            },
            {
              type: "SubmenuLink",
              label: "Horizontal-spülbohrverfahren",
              link: "/fachzeitschriften/umweltbau/bauverfahren/horizontalspuelbohrverfahren",
            },
            {
              type: "SubmenuLink",
              label: "Microtunneling",
              link: "/fachzeitschriften/umweltbau/bauverfahren/microtunneling",
            },
            {
              type: "SubmenuLink",
              label: "Pflugverfahren",
              link: "/fachzeitschriften/umweltbau/bauverfahren/pflugverfahren",
            },
            {
              type: "SubmenuLink",
              label: "Pipe Express",
              link: "/fachzeitschriften/umweltbau/bauverfahren/pipe-express",
            },
            {
              type: "SubmenuLink",
              label: "Rammverfahren",
              link: "/fachzeitschriften/umweltbau/bauverfahren/rammverfahren",
            },
            {
              type: "SubmenuLink",
              label: "Schlauchlining",
              link: "/fachzeitschriften/umweltbau/bauverfahren/schlauchlining",
            },
            {
              type: "SubmenuLink",
              label: "Sprühschleuderverfahren",
              link: "/fachzeitschriften/umweltbau/bauverfahren/spruehschleuderverfahren",
            },
            {
              type: "SubmenuLink",
              label: "Wickelrohrverfahren",
              link: "/fachzeitschriften/umweltbau/bauverfahren/wickelrohrverfahren",
            },
            {
              type: "SubmenuLink",
              label: "Einzelrohrlining",
              link: "/fachzeitschriften/umweltbau/bauverfahren/einzelrohrlining",
            },
          ],
        },
        {
          type: "BfzLogo",
          link: "/fachzeitschriften/umweltbau",
          page: "umweltbau",
          width: "140px",
          height: "32px",
          title: "B_I umweltbau Logo",
        },
      ]
